export const config = {
  ...globalThis.EnvConfig.env
}
